import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StandardPrintingHeader from './StandardPrintingHeader';
import StandardPrintingSidebar from './StandardPrintingSidebar';
import StandardPrintingContent from './StandardPrintingContent';
import {
  usePrintQuestionsMutation,
  useGetPrintSettingsMutation
} from '../../../../../features/authentication/assignApiSlice';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';

const baseUrl = appConfig.apiBaseUrl;
const StandardPrinting = () => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();
  const { assignmentId, assignmentName } = location.state;
  const [printAssignmentQuestions] = usePrintQuestionsMutation();
  const [printSettings] = useGetPrintSettingsMutation();
  const [initialQuestionData, setInitialQuestionData] = useState([]);
  const [sequenceId, setSequenceId] = useState([]);
  const [settingsData, setSettingsData] = useState({});
  const [dragged, setDragged] = useState(false);
  const [gotoId, setGotoId] = useState(null);

  const updateSettings = (data) => {
    setSettingsData({ ...settingsData, ...data });
    addPrintSettingsAsync({ ...settingsData, ...data });
  };

  const getPrintSettingsAsync = async () => {
    const options = {
      assignmentId: assignmentId
    };
    const printSettingsResponse = await printSettings(options).unwrap();
    updateSettings({
      fontStyleData: printSettingsResponse.fontstyle,
      fontSizeData: printSettingsResponse.fontsize,
      mcSpacingData: printSettingsResponse.mcspacing,
      mcStylingData: printSettingsResponse.mcstyle,
      teacherName: printSettingsResponse.teachername,
      displayAnswer: printSettingsResponse.displayanswer,
      dueDate: printSettingsResponse.duedate,
      crAnswerSpace: printSettingsResponse.cranswerspace,
      fiAnswerSpace: printSettingsResponse.fianswerspace,
      mcAnswerSpace: printSettingsResponse.mcanswerspace,
      instructions: printSettingsResponse.instructions,
      showAssignment: printSettingsResponse.showassignment,
      showClass: printSettingsResponse.showclass,
      showName: printSettingsResponse.showname,
      showTeacher: printSettingsResponse.showteacher,
      answerKey: printSettingsResponse.answerkey,
      questions: null
    });
  };

  const getPrintAssignmentQuestionsAsync = async () => {
    const options = {
      assignmentId: assignmentId
    };
    const printAssignmentQuestionsResponse = await printAssignmentQuestions(options).unwrap();
    setInitialQuestionData(printAssignmentQuestionsResponse);
    let sequenceIdArr = [];
    sequenceIdArr = printAssignmentQuestionsResponse.map((item) => {
      return item.questionId;
    });
    setSequenceId(sequenceIdArr);
  };

  const addPrintSettingsAsync = async (data) => {
    try {
      const options = {
        fontstyle: data?.fontStyleData,
        fontsize: data?.fontSizeData,
        answerkey: data?.answerKey,
        displayanswer: data?.displayAnswer,
        showname: data?.showName,
        showclass: data?.showClass,
        showassignment: data?.showAssignment,
        showteacher: data?.showTeacher,
        instructions: data?.instructions,
        duedate: data?.dueDate,
        teachername: data?.teacherName,
        mcspacing: data?.mcSpacingData,
        mcstyle: data?.mcStylingData,
        mcanswerspace: data?.mcAnswerSpace,
        fianswerspace: data?.fiAnswerSpace,
        cranswerspace: data?.crAnswerSpace,
        questions: null
      };
      let url = baseUrl + '/Assignment/AddPrintSettings';
      url += '?assignmentId=' + assignmentId;
      if (dragged) {
        if (sequenceId && sequenceId.length > 0) {
          sequenceId.forEach((item, index) => {
            url += `${index === 0 ? '&' : ''}qidList=${item}${
              sequenceId.length !== index + 1 ? '&' : ''
            }`;
          });
        }
      }
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      };
      await fetch(url, {
        headers,
        method: 'POST',
        body: JSON.stringify(options)
      });
    } catch (ex) {
      console.log(ex);
    }
  };

  const updateQuestionDetails = (updatedData) => {
    setInitialQuestionData(updatedData);
    let sequenceIdArr = [];
    sequenceIdArr = updatedData.map((item) => {
      return item.questionId;
    });
    setSequenceId(sequenceIdArr);
    setDragged(true);
  };

  useEffect(() => {
    getPrintSettingsAsync();
  }, []);

  useEffect(() => {
    getPrintAssignmentQuestionsAsync();
  }, []);

  useEffect(() => {
    if (sequenceId.length > 0) {
      addPrintSettingsAsync(settingsData);
    }
  }, [sequenceId]);

  return (
    <div className="printing-container">
      <div className="row">
        <div className="col-lg-3">
          <StandardPrintingSidebar
            questionDetails={initialQuestionData}
            updateQuestionDetails={updateQuestionDetails}
            setGotoId={setGotoId}
          />
        </div>
        <div className="col-lg-9">
          <StandardPrintingHeader
            updateSettings={updateSettings}
            fontSizeValue={settingsData?.fontSizeData}
            fontStyleValue={settingsData?.fontStyleData}
            mcSpaceValue={settingsData?.mcSpacingData}
            mcstyleValue={settingsData?.mcStylingData}
            answerKeyValue={settingsData?.answerKey}
            assignmentName={assignmentName}
            assignmentId={assignmentId}
          />
          <StandardPrintingContent
            assignmentName={assignmentName}
            fontStyleData={settingsData?.fontStyleData}
            fontSizeData={settingsData?.fontSizeData}
            mcSpacingData={settingsData?.mcSpacingData}
            mcStylingData={settingsData?.mcStylingData}
            answerKey={settingsData?.answerKey}
            questionDetails={initialQuestionData}
            teacherNameData={settingsData?.teacherName}
            dueDate={settingsData?.dueDate}
            initialInstructions={settingsData?.instructions}
            updateSettings={updateSettings}
            settingsData={settingsData}
            gotoId={gotoId}
          />
        </div>
      </div>
    </div>
  );
};

export default StandardPrinting;
